export const rowReverseStyle = (isArabic) => (isArabic ? 'flex-row-reverse' : 'flex-row');
export const rowReverseStylesm = (isArabic) => (isArabic ? 'sm:flex-row-reverse' : 'sm:flex-row');
export const rowReverseStylemd = (isArabic) => (isArabic ? 'md:flex-row-reverse' : 'md:flex-row');
export const rowReverseStylexl = (isArabic) => (isArabic ? 'xl:flex-row-reverse' : 'xl:flex-row');
export const rowReverseStyle2xl = (isArabic) => (isArabic ? '2xl:flex-row-reverse' : '2xl:flex-row');

export const rowStyle = (isArabic) =>
  isArabic
    ? {
        flexDirection: 'row-reverse',
      }
    : {
        flexDirection: 'row',
      };

export const rotateIcon = (isArabic) => (isArabic ? 'rotate-180' : '');
